import React from "react";

import { Box, Grid } from "@material-ui/core";
import BrandPositionsDropdown from "./BrandPositionsDropdown";
import PlaceSuperCategoriesDropdown from "./PlaceSuperCategoryDropdown";
import StoreSizesDropdown from "./StoreSizeDropdown";

const Filter: React.FC = () => {
    return (
        <Box>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <PlaceSuperCategoriesDropdown />
                </Grid>
                <Grid item xs={12}>
                    <BrandPositionsDropdown />
                </Grid>
                <Grid item xs={12}>
                    <StoreSizesDropdown />
                </Grid>
            </Grid>
        </Box>
    );
};

export default Filter;
